export default {"src":"/_next/static/media/home_credit_icon.910e9cf4.svg","height":79,"width":86,"blurWidth":0,"blurHeight":0};